import { LegalPage, LegalH2 } from "@/components/LegalPage";
import { COMPANY } from "@/lib/company";

export default function About() {
  return (
    <LegalPage title="Hakkımızda" testid="about-page">
      <p>
        {COMPANY.brand}, {COMPANY.owner} tarafından {COMPANY.since} yılından bu yana İstanbul'da markaların
        ürünlerini, üretimlerini ve hikâyelerini görüntüye dönüştüren bir reklam fotoğrafçılığı ve
        prodüksiyon stüdyosudur. Bugün bu deneyimi yapay zeka ile birleştirerek; kısa film, reklam filmi
        ve sosyal medya içerikleri için fikirden teslime kadar tüm prodüksiyon sürecini tek platformda
        yönetiyoruz.
      </p>

      <LegalH2>Ne Yapıyoruz?</LegalH2>
      <p>
        Müşterilerimiz portalımız üzerinden fikirlerini paylaşır; yapay zeka destekli sistemimiz
        sinematik senaryo taslakları üretir. Onaylanan senaryo, stüdyomuzun deneyimli ekibi tarafından
        hayata geçirilir. Süreç boyunca her adım (fikir, senaryo, onay, teklif, ödeme, üretim, teslim)
        şeffaf bir şekilde takip edilebilir.
      </p>

      <LegalH2>Vizyonumuz</LegalH2>
      <p>
        Yaratıcılığı teknolojiyle birleştirerek, her ölçekten markanın ve bireyin kaliteli görsel
        hikâye anlatımına erişebilmesini sağlamak.
      </p>

      <LegalH2>Kurumsal & İletişim Bilgileri</LegalH2>
      <p>
        Ticari Ünvan: {COMPANY.legalName}<br />
        Vergi Dairesi / No: {COMPANY.taxOffice} V.D. — {COMPANY.taxNo}<br />
        Faaliyet Konusu: {COMPANY.activity}<br />
        Adres: {COMPANY.address}<br />
        E-posta: {COMPANY.email}<br />
        Telefon: {COMPANY.phone}<br />
        Web: {COMPANY.web}
      </p>
    </LegalPage>
  );
}
